import { useDispatch, useSelector } from "react-redux";
import ActivityGraph from "../../components/graphs/ActivityGraph";
import RecentTransactions from "../../components/cards/RecentTransactions";
import StatCards from "../../components/cards/StatCards";
import MainContainer from "../../components/container/MainContainer";
import { useEffect } from "react";
import { getNarativeReports } from "../../features/reportsSlice";
import { getProjectRequests } from "../../features/projectsSlice";
import { Link } from "react-router-dom";
import { Table2 } from "lucide-react";

const CommunityCouncilDashBoard = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.userInfo);
  const narratives = useSelector((state) => state.reports.naratives);
  const projects = useSelector((state) => state.projects.data);

  useEffect(() => {
    if (user.id) {
      dispatch(
        getNarativeReports({
          limit: 10,
          offset: 0,
          community_id: user.community ? user.communities[0].id : null,
        })
      );
    }

    if (user.id && user.communities.length > 0) {
      dispatch(
        getProjectRequests({
          limit: 5,
          offset: 0,
          desk: "community",
          id: user.province_id,
          community_id: user.communities?.[0]?.id,
        })
      );
    }
  }, [user]);

  return (
    <MainContainer>
      <div className="flex-1 w-full h-full  mb-5">
        {user.id && (
          <div className="flex-1 h-full ">
            <div className="border border-bkg2 p-2 rounded-md bg-content mb-3 font-roboto">
              <p className="text-lg font-roboto font-bold mb-2 text-center">
                Hello,
                <span className=" font-medium">
                  {" " + user.first_name + " " + user.last_name}
                </span>
              </p>

              <p>
                <span>{user.province?.name || "N/A"}</span>
              </p>
              <p>Community:{" " + user.community || "N/A"}</p>
              <p>Role:{" " + user.role || "N/A"}</p>
            </div>
            <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
              <ActivityGraph />
              {/* Table of Initatives For Community Title */}
              <div className="bg-content flex-1 shadow-lg h-60 rounded-lg p-3">
                <div className="flex items-center justify-between mb-4">
                  <h5 className="flex items-center gap-1.5 font-medium text-text-1/80">
                    <Table2 size={18} /> Community Approvals
                  </h5>
                  <Link
                    className="text-sm text-primary hover:underline"
                    to="/requests/community-approvals"
                  >
                    See all
                  </Link>
                </div>
                {/* The Table */}
                <div className="table-container w-full overflow-auto relative">
                  <table className="text-text-1/75">
                    <thead>
                      <tr className="text-text-1/80 sticky border-b border-b-text-2/50">
                        <th>No.</th>
                        <th>Title</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {projects.map((item, index) => (
                        <tr key={index}>
                          <td>{++index}</td>
                          <td>
                            {item.name.length >= 20
                              ? item.name.slice(0, 25) + "....."
                              : item.name}
                          </td>
                          <td>{item.stage.step || "Not Started"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="flex flex-1 flex-col sm:flex-row sm:items-center sm:justify-between gap-5 mb-5 sm:h-auto">
              <RecentTransactions narratives={narratives} />
            </div>
          </div>
        )}
      </div>
    </MainContainer>
  );
};

export default CommunityCouncilDashBoard;
